import { render, staticRenderFns } from "./TeamCreateDetailInfo.vue?vue&type=template&id=1c258d5f&"
import script from "./TeamCreateDetailInfo.vue?vue&type=script&lang=ts&"
export * from "./TeamCreateDetailInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports